(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

     connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.lastMouseX = -1;
      this.lastMouseY = -1;
      this.onPointerMove = (e) => {
        this.lastMouseX = e.clientX;
        this.lastMouseY = e.clientY;
      };
      window.addEventListener('pointermove', this.onPointerMove, { passive: true });

      this.onMouseEnter = () => { this.isHovered = true; };
      this.onMouseLeave = () => { this.isHovered = false; };
      this.addEventListener('mouseenter', this.onMouseEnter);
      this.addEventListener('mouseleave', this.onMouseLeave);
      if (this.header) {
        this.header.addEventListener('mouseenter', this.onMouseEnter);
        this.header.addEventListener('mouseleave', this.onMouseLeave);
      }

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      /* --- FIX: hard, timing-independent guarantee that the sticky header
         cannot hide while a nav menu or submenu is open -----------------
         `toggle` events on <details> do not bubble, so this listener is
         registered on `document` with `capture: true` so it still fires
         for any nested <details> inside the header, regardless of the
         order other `toggle` listeners (header-menu.js) run in, and
         regardless of whether a scroll event happens to fire at the same
         moment the user's cursor is travelling toward the submenu. */
      this.onDetailsToggle = (event) => {
        if (!event.target || event.target.tagName !== 'DETAILS') return;
        if (!this.header || !this.header.contains(event.target)) return;
        const openDetailsList = Array.from(this.header.querySelectorAll('details[open]'));
        const anyOpen = openDetailsList.some(el => {
          let parent = el.parentElement ? el.parentElement.closest('details') : null;
          while (parent) {
            if (!parent.hasAttribute('open')) return false;
            parent = parent.parentElement ? parent.parentElement.closest('details') : null;
          }
          return true;
        });
        this.preventHide = anyOpen;
        if (anyOpen) {
          // Cancel any debounced hide() still pending from an in-flight
          // scroll, and force the header back into view immediately if it
          // happened to be mid-hide already.
          clearTimeout(this.hideDebounceTimer);
          this.reveal();
        } else {
          if (this.header) this.header.classList.remove('menu-open');
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const headerTop = (this.headerBounds && typeof this.headerBounds.top === 'number') ? this.headerBounds.top : 0;
          if (scrollTop <= headerTop) {
            this.reset();
          }
        }
      };
      document.addEventListener('toggle', this.onDetailsToggle, true);
      /* ------------------------------------------------------------------ */

      this.initTransparentHeader();
      this.createObserver();

      // Listen for any modal, drawer, or disclosure close events to sanitize header state
      this.onOverlayClose = () => {
        const openDetailsList = Array.from(document.querySelectorAll('.section-header details[open], .header-wrapper details[open], sticky-header details[open]'));
        const hasOpenDetails = openDetailsList.some(el => {
          let parent = el.parentElement ? el.parentElement.closest('details') : null;
          while (parent) {
            if (!parent.hasAttribute('open')) return false;
            parent = parent.parentElement ? parent.parentElement.closest('details') : null;
          }
          return true;
        });
        if (!hasOpenDetails) {
          this.preventHide = false;
          if (this.header) {
            this.header.preventHide = false;
            this.header.classList.remove('menu-open');
          }
          const headerWrapper = document.querySelector('.header-wrapper');
          if (headerWrapper) {
            headerWrapper.preventHide = false;
            headerWrapper.classList.remove('menu-open');
          }
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const headerTop = (this.headerBounds && typeof this.headerBounds.top === 'number') ? this.headerBounds.top : 0;
          if (scrollTop <= headerTop) {
            this.reset();
          }
        }
        const isSearchOpen = !!(this.querySelector('details-modal[open], predictive-search[open]') || document.querySelector('details-modal[open]'));
        if (this.predictiveSearch && !isSearchOpen) {
          this.predictiveSearch.isOpen = false;
        }
        this.setHeaderHeight();
      };

      document.body.addEventListener('modalClosed', this.onOverlayClose);
      document.addEventListener('cart-drawer:closed', this.onOverlayClose);
      document.addEventListener('transitionend', (e) => {
        if (e.target && (e.target.matches('cart-drawer, modal-dialog, quick-add-modal, details-modal') || e.target.classList.contains('drawer'))) {
          this.onOverlayClose();
        }
      });

      // Initial check on load to hide bottom nav at top of page
      const initialScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const isMobileOnLoad = window.matchMedia('(max-width: 749px)').matches;
      if (isMobileOnLoad && initialScrollTop <= 50) {
        this.toggleMobileStickyFooter(false);
      }

      // Enable transitions after a short delay to prevent page load flash
      setTimeout(() => {
        this.classList.add('header-wrapper--transition');
      }, 100);
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.onOverlayClose) {
        document.body.removeEventListener('modalClosed', this.onOverlayClose);
        document.removeEventListener('cart-drawer:closed', this.onOverlayClose);
      }
      if (this.onPointerMove) {
        window.removeEventListener('pointermove', this.onPointerMove);
      }
      if (this.onDetailsToggle) {
        document.removeEventListener('toggle', this.onDetailsToggle, true); // FIX: cleanup added listener
      }
      clearTimeout(this.hideDebounceTimer); // FIX: cleanup debounced hide timer
      this.removeEventListener('mouseenter', this.onMouseEnter);
      this.removeEventListener('mouseleave', this.onMouseLeave);
      if (this.header) {
        this.header.removeEventListener('mouseenter', this.onMouseEnter);
        this.header.removeEventListener('mouseleave', this.onMouseLeave);
      }
    }

    initTransparentHeader() {
      this.enableTransparentHeader = this.getAttribute('data-transparent-header') === 'true';
      this.isHomepage = window.location.pathname === '/' || window.location.pathname === '/challenge' || document.body.classList.contains('template-index') || (document.querySelector('main')?.dataset.template === 'index');
      
      if (this.enableTransparentHeader && this.isHomepage) {
        this.header.classList.add('header-transparent-active');
        // this.inlineAndStyleLogo();
        this.updateHeaderBackground();
        
        // Listen to slideshow slide changes to update header color scheme
        const slideshow = document.querySelector('slideshow-component');
        if (slideshow) {
          slideshow.addEventListener('scroll', () => {
            requestAnimationFrame(this.updateHeaderBackground.bind(this));
          });
        }
      }
    }

    inlineAndStyleLogo() {
      // CLS Optimization: Retain <img> in DOM to avoid layout shifts from async replacement.
      // Transparent header logo contrast is handled via pure CSS filter (brightness(0) invert(1)).
      return;
    }

    updateHeaderBackground() {
      if (!this.enableTransparentHeader || !this.isHomepage) return;

      const headerHeight = this.header.offsetHeight;
      const scrollY = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollY <= 10) {
        this.classList.add('header-transparent');
        
        // Match the first section's color scheme for text/icon contrast
        const firstSection = document.querySelector('#MainContent .shopify-section');
        if (firstSection) {
          let colorSchemeClass = null;
          if (firstSection.tagName.toLowerCase() === 'slideshow-component' || firstSection.querySelector('slideshow-component')) {
            const activeSlide = firstSection.querySelector('.slideshow__slide[aria-hidden="false"]') || firstSection.querySelector('.slideshow__slide');
            if (activeSlide) {
              colorSchemeClass = Array.from(activeSlide.classList).find(c => c.startsWith('color-scheme-') || c.startsWith('color-'));
              if (!colorSchemeClass) {
                const childWithColorScheme = activeSlide.querySelector('[class*="color-scheme-"], [class*="color-"]');
                if (childWithColorScheme) {
                  colorSchemeClass = Array.from(childWithColorScheme.classList).find(c => c.startsWith('color-scheme-') || c.startsWith('color-'));
                }
              }
            }
          }
          
          if (!colorSchemeClass) {
            colorSchemeClass = Array.from(firstSection.classList).find(c => c.startsWith('color-scheme-') || c.startsWith('color-'));
            if (!colorSchemeClass) {
              const childWithColorScheme = firstSection.querySelector('[class*="color-scheme-"], [class*="color-"]');
              if (childWithColorScheme) {
                colorSchemeClass = Array.from(childWithColorScheme.classList).find(c => c.startsWith('color-scheme-') || c.startsWith('color-'));
              }
            }
          }

          if (colorSchemeClass) {
            const currentScheme = Array.from(this.classList).find(c => c.startsWith('color-scheme-') || c.startsWith('color-'));
            if (currentScheme !== colorSchemeClass) {
              this.className = this.className.replace(/\bcolor-\S+\b/g, '');
              this.classList.add(colorSchemeClass);
            }
          }
        }
        return;
      }

      // Otherwise, we are scrolling and the header should be solid
      this.classList.remove('header-transparent');

      // Find the active section under the header
      const headerRect = this.getBoundingClientRect();
      const checkY = headerRect.top + headerRect.height / 2;
      const sections = Array.from(document.querySelectorAll('#MainContent .shopify-section'));
      
      let activeSection = null;
      let activeSectionIndex = -1;
      for (let i = 0; i < sections.length; i++) {
        const rect = sections[i].getBoundingClientRect();
        if (rect.top <= checkY && rect.bottom >= checkY) {
          activeSection = sections[i];
          activeSectionIndex = i;
          break;
        }
      }

      const defaultScheme = 'color-' + this.getAttribute('data-default-color-scheme');

      // If we are over the first section (slideshow/hero banner), force default solid scheme
      if (activeSectionIndex === 0 || !activeSection) {
        const currentScheme = Array.from(this.classList).find(c => c.startsWith('color-scheme-') || c.startsWith('color-'));
        if (currentScheme !== defaultScheme) {
          this.className = this.className.replace(/\bcolor-\S+\b/g, '');
          this.classList.add(defaultScheme);
        }
      } else {
        // For other sections, match color scheme dynamically
        let colorSchemeClass = null;
        if (activeSection.tagName.toLowerCase() === 'slideshow-component' || activeSection.querySelector('slideshow-component')) {
          const activeSlide = activeSection.querySelector('.slideshow__slide[aria-hidden="false"]') || activeSection.querySelector('.slideshow__slide');
          if (activeSlide) {
            colorSchemeClass = Array.from(activeSlide.classList).find(c => c.startsWith('color-scheme-') || c.startsWith('color-'));
            if (!colorSchemeClass) {
              const childWithColorScheme = activeSlide.querySelector('[class*="color-scheme-"], [class*="color-"]');
              if (childWithColorScheme) {
                colorSchemeClass = Array.from(childWithColorScheme.classList).find(c => c.startsWith('color-scheme-') || c.startsWith('color-'));
              }
            }
          }
        }

        if (!colorSchemeClass) {
          colorSchemeClass = Array.from(activeSection.classList).find(c => c.startsWith('color-scheme-') || c.startsWith('color-'));
          if (!colorSchemeClass) {
            const childWithColorScheme = activeSection.querySelector('[class*="color-scheme-"], [class*="color-"]');
            if (childWithColorScheme) {
              colorSchemeClass = Array.from(childWithColorScheme.classList).find(c => c.startsWith('color-scheme-') || c.startsWith('color-'));
            }
          }
        }

        // Avoid transparent scheme-5 background when scrolled
        if (colorSchemeClass === 'color-scheme-5') {
          colorSchemeClass = defaultScheme;
        }

        if (colorSchemeClass) {
          const currentScheme = Array.from(this.classList).find(c => c.startsWith('color-scheme-') || c.startsWith('color-'));
          if (currentScheme !== colorSchemeClass) {
            this.className = this.className.replace(/\bcolor-\S+\b/g, '');
            this.classList.add(colorSchemeClass);
          }
        } else {
          const currentScheme = Array.from(this.classList).find(c => c.startsWith('color-scheme-') || c.startsWith('color-'));
          if (currentScheme !== defaultScheme) {
            this.className = this.className.replace(/\bcolor-\S+\b/g, '');
            this.classList.add(defaultScheme);
          }
        }
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    isInteractionActive() {
      const headerEl = this.header || this;

      // 1. Dynamic check for visible open details (menus, submenus) or active drawer/modal overlays in DOM
      const openDetailsList = Array.from(document.querySelectorAll('.section-header details[open], .header-wrapper details[open], sticky-header details[open]'));
      const hasOpenDetails = openDetailsList.some(el => {
        let parent = el.parentElement ? el.parentElement.closest('details') : null;
        while (parent) {
          if (!parent.hasAttribute('open')) return false;
          parent = parent.parentElement ? parent.parentElement.closest('details') : null;
        }
        return true;
      });

      const isOverlayActive = !!document.querySelector(
        'cart-drawer.active, cart-notification.active, quick-add-modal[open], modal-dialog[open], .popup-modal[open]'
      );

      if (!hasOpenDetails) {
        this.preventHide = false;
        if (headerEl) {
          headerEl.preventHide = false;
          headerEl.classList.remove('menu-open');
        }
        const headerWrapper = document.querySelector('.header-wrapper');
        if (headerWrapper) {
          headerWrapper.preventHide = false;
          headerWrapper.classList.remove('menu-open');
        }
      }

      if (hasOpenDetails || isOverlayActive) {
        return true;
      }

      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const activeEl = document.activeElement;
      const isTextInput = activeEl && (activeEl.tagName === 'INPUT' || activeEl.tagName === 'TEXTAREA' || activeEl.isContentEditable);

      const isHovered = !isMobile && (
        this.isHovered ||
        this.matches(':hover') ||
        (headerEl && headerEl.matches(':hover')) ||
        !!(headerEl && headerEl.querySelector('header-menu:hover, header-submenu:hover, .header__submenu:hover, .mega-menu__content:hover'))
      );

      const isFocused = !isMobile
        ? (this.contains(activeEl) || (headerEl && headerEl.contains(activeEl)))
        : isTextInput;

      if (isHovered || isFocused) {
        return true;
      }

      // 2. Real-time cursor coordinates vs bounding rects of header and dropdowns (desktop hover safety)
      if (!isMobile && this.lastMouseX >= 0 && this.lastMouseY >= 0) {
        const rect = headerEl.getBoundingClientRect();
        if (
          this.lastMouseX >= rect.left - 10 &&
          this.lastMouseX <= rect.right + 10 &&
          this.lastMouseY >= rect.top - 10 &&
          this.lastMouseY <= rect.bottom + 10
        ) {
          return true;
        }

        const openElements = headerEl.querySelectorAll('details[open], .header__submenu, .mega-menu__content, header-menu, header-submenu');
        for (const el of openElements) {
          const elRect = el.getBoundingClientRect();
          if (
            elRect.width > 0 && elRect.height > 0 &&
            this.lastMouseX >= elRect.left - 10 &&
            this.lastMouseX <= elRect.right + 10 &&
            this.lastMouseY >= elRect.top - 10 &&
            this.lastMouseY <= elRect.bottom + 10
          ) {
            return true;
          }
        }
      }

      return false;
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      const isSearchModalOpen = !!(
        this.querySelector('details-modal[open], predictive-search[open]') ||
        document.querySelector('details-modal[open]')
      );
      if (isSearchModalOpen) return;

      const headerBottom = (this.headerBounds && typeof this.headerBounds.bottom === 'number') ? this.headerBounds.bottom : (this.header ? this.header.offsetHeight : 100);
      const headerTop = (this.headerBounds && typeof this.headerBounds.top === 'number') ? this.headerBounds.top : 0;

      /* --- FIX: ignore sub-pixel / momentum-scroll noise once we're past
         the header. Trackpads and some mice keep emitting tiny residual
         `scroll` events for a short time after the user physically stops
         scrolling. Previously, if one of those fired at the exact moment
         the cursor was travelling from the header toward a menu item (but
         hadn't yet entered the hover hitbox on that animation frame),
         `isInteractionActive()` returned false and `hide()` ran, yanking
         the header away before the user could reach the submenu. A ~3px
         threshold filters out that noise while leaving real scroll
         gestures completely unaffected. */
      const scrollDelta = scrollTop - this.currentScrollTop;
      if (Math.abs(scrollDelta) < 3 && scrollTop > headerBottom) {
        this.currentScrollTop = scrollTop;
        return;
      }
      /* ------------------------------------------------------------------ */

      const isMobile = window.matchMedia('(max-width: 749px)').matches;

      if (scrollTop > this.currentScrollTop && scrollTop > headerBottom) {
        this.header.classList.add('scrolled-past-header');
        if (isMobile) {
          requestAnimationFrame(() => {
            this.hide();
            this.toggleMobileStickyFooter(true);
          });
        } else {
          /* --- FIX: debounce the hide decision instead of committing to
             it on the very next paint. When a menu is opened via
             mouseenter while a scroll is still in flight, the browser
             can dispatch the <details> 'toggle' event as a separate
             queued task that is NOT guaranteed to run before the next
             requestAnimationFrame callback. That race let hide() win
             and slide the header away a frame before the menu-open
             signal had actually registered, even though the user was
             already hovering the item. Waiting ~120ms and re-checking
             isInteractionActive() right before hiding gives any
             in-flight menu-open (and its toggle event) time to land
             first, so a real hover always wins the race. */
          clearTimeout(this.hideDebounceTimer);
          this.hideDebounceTimer = setTimeout(() => {
            if (!this.isInteractionActive()) {
              this.hide();
            }
          }, 120);
          /* ------------------------------------------------------------ */
        }
      } else if (scrollTop < this.currentScrollTop && scrollTop > headerBottom) {
        this.header.classList.add('scrolled-past-header');
        if (isMobile) {
          requestAnimationFrame(() => {
            this.reveal();
            this.toggleMobileStickyFooter(false);
          });
        } else {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
      } else if (scrollTop <= headerTop) {
        this.header.classList.remove('scrolled-past-header');
        if (isMobile) {
          requestAnimationFrame(() => {
            this.reset();
            this.toggleMobileStickyFooter(false);
          });
        } else {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
      this.updateHeaderBackground();
    }

    hide() {
      if (this.isInteractionActive()) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      if (this.header && this.header.contains(document.activeElement)) {
        document.activeElement.blur();
      }
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      clearTimeout(this.hideDebounceTimer); // FIX: don't let a stale debounced hide fire after revealing
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      clearTimeout(this.hideDebounceTimer); // FIX: don't let a stale debounced hide fire after resetting
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }

    toggleMobileStickyFooter(show) {
      const bottomNav = document.getElementById('mobile-bottom-nav');
      if (bottomNav) {
        if (show) {
          bottomNav.classList.remove('mobile-bottom-nav--hidden');
        } else {
          bottomNav.classList.add('mobile-bottom-nav--hidden');
        }
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
